export enum DATE_FORMAT_STRING {
  MM_dd_yyyy = 'MM/dd/yyyy',
  yyyy_MM_dd = 'yyyy-MM-dd',
}

export enum TIME_FORMAT_STRING {
  LONG_LOCALIZED_TIME = 'p',
}

export enum DATE_AND_TIME_FORMAT_STRING {
  MM_dd_yyyy_hh_mm_a = 'MM/dd/yyyy hh:mm a',
}

export const NOTIFICATION_SENT_AT_FORMAT = 'MM/dd/yyyy hh:mm:ss a'
